import { ReactElement } from 'react'
import styled from 'styled-components'
import { MessageInfo } from './interfaces'
import { MessageItem } from './MessageItem'

interface MessageItemListProps {
  items: Array<MessageInfo>
  hideLink?: boolean
}

export const MessageItemList = (props: MessageItemListProps): ReactElement => {
  const { items, hideLink } = props

  return (
    <FlexColumn>
      {items.map((item, index) => (
        <MessageItem
          key={item.link.text + index}
          item={item}
          hideLink={hideLink}
        />
      ))}
    </FlexColumn>
  )
}

const FlexColumn = styled.div`
  padding-top: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: start;
  min-width: 0;
  max-width: 100%;
`
